<template>
    <v-card>
        <v-card-title class="accent white--text subheading">
            {{'Anomaly Detection Scores (Higher indicates error)'|translate}}
            <v-spacer></v-spacer>
            <v-btn color="primary" fab small dark @click.prevent="$refs.explanationDialog.openDialog()">
                <v-icon>fa-info</v-icon>
            </v-btn>
            <anomaly-explanation-dialog ref="explanationDialog"></anomaly-explanation-dialog>
        </v-card-title>
        <v-card-text style="min-height: 200px">
            <loading-progress-bar :loading="loading"></loading-progress-bar>
            <v-layout v-if="!loading && noData" row wrap justify-center align-center style="min-height: 200px">
                <v-flex xs12 class="text-xs-center">
                    <v-icon large class="mb-2">fa-exclamation-circle</v-icon>
                    <p class="headline">{{'No anomaly model available for this equipment'|translate}}</p>
                </v-flex>
            </v-layout>
            <vue-plotly disable-responsive v-if="showCol&&!loadingFirst&&!noData" :data="mydata" :layout="layout" ref="plot1" :options="options" @click="handleClick1"></vue-plotly>
            <vue-plotly disable-responsive v-if="showCol&&!loading&&!noData" :data="mySumData" :layout="sumLayout" ref="plot2" :options="options" @click="handleClick1"></vue-plotly>
        </v-card-text>
        <v-card-text>
            <vue-plotly disable-responsive  v-if="showCol2&&mydata2" :data="mydata2" :layout="layout2" :options="options" @click="handleClickMatrix"></vue-plotly>
        </v-card-text>
        <v-card-text>
            <anomaly-scatter-plot
                    :facility-name="facilityName"
                    :equipment-name="equipment"
                    :selected-time="currentTime"
                    :variable-y="variableY"
                    :variable-x="variableX"
                    anomaly-name="CHWR_Temp__CHWS_Temp"
                    ref="anomalyscatter"
            >
            </anomaly-scatter-plot>
            <v-layout
                    row>
                <v-spacer></v-spacer>
                <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"></fault-record-dialog>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
    import {getAnomalies, getAnomaliesSummary} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import LoadingProgressBar from '../LoadingProgressBar'
    import AnomalyExplanationDialog from '../anomaly/AnomalyExplanationDialog'
    import AnomalyScatterPlot from './AnomalyScatterPlot'
    import moment from 'moment'
    import FaultRecordDialog from "../FaultRecordDialog";
    export default {
        name: 'AnomalySummary',
        components: { AnomalyScatterPlot, AnomalyExplanationDialog, LoadingProgressBar, VuePlotly,FaultRecordDialog},
        props:{
            range: Object,
            equipment: String
        },
        data () {
            return {
                variableX: null,
                variableY: null,
                maintenanceDialog: false,
                maintenanceItem: null,
                plots:[],
                timeout:null,
                loadingMRButton:false,
                loading: true,
                loadingFirst: true,
                noData: false,
                df: null,
                showCol:true,
                showCol2:true,
                layout: {
                    autosize: true,
                    hovermode: 'closest',
                    height: 200,
                    yaxis: {
                        title: this.$options.filters.translate('Health'),
                    },
                    xaxis: {
                        title: this.$options.filters.translate('Time')
                    },
                    margin:{
                        l: 300,
                    },
                },
                sumLayout: {
                    hovermode: 'closest',
                    height:400,
                    autosize: true,
                    margin:{
                        l: 300,
                        r: 50,
                        b: 160,
                        t: 30,
                        pad: 4
                    },
                    yaxis: {
                        title: this.$options.filters.translate('Sensor'),
                        fixedrange: true,
                    },
                    xaxis: {
                        title: this.$options.filters.translate('Time')
                    }
                },
                options: {},
                mydata: [],
                mySumData: [],
                mydata2: null,
                layout2: {
                    autosize: true,
                    height:400,
                    hovermode: 'closest',
                    margin:{
                        l: 300,
                        r: 50,
                        b: 160,
                        t: 30,
                        pad: 4
                    },
                    yaxis: {
                        title: this.$options.filters.translate('Sensor')
                    },
                    xaxis: {
                        title: this.$options.filters.translate('Sensor')
                    },
                    title: {text: ''}
                },
                currentTime: null
            }
        },
        watch: {
            range () {
                this.refresh()
            },
            equipment () {
                this.mydata2=null;
                this.refresh()
            }
        },
        computed: {
            facilityName () {
                return this.$store.state.pointsListStore.pointsList.facility_name
            }
        },
        methods: {
            relayout(ed) {
                for (let plot of this.plots){
                    let x = plot.layout.xaxis;
                    if (x.range[0] !== ed["xaxis.range[0]"] || x.range[1] !== ed["xaxis.range[1]"]){
                        plot.relayout( ed);
                    }
                }
            },
            initPlotlySync(){
                let plots=[]
                let me=this;
                if(!this.$refs.plot1||!this.$refs.plot2){
                    setTimeout(function(){ me.initPlotlySync()}, 400);
                } else {
                    plots.push(this.$refs.plot1.$refs.container)
                    plots.push(this.$refs.plot2.$refs.container)
                    me.plots=plots;
                    plots.forEach(div => {
                        div.$el.on("plotly_relayout", ed=> {
                            if (!ed.autosize){
                                let newl={
                                    "xaxis.range[0]":div.layout.xaxis.range[0],
                                    "xaxis.range[1]":div.layout.xaxis.range[1],
                                }
                                me.relayout(newl);
                            }

                        });
                    });
                }



            },
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.doRefresh,200);
            },
            async doRefresh () {
                this.loading = true
                this.loadingFirst = true
                this.noData = false
                let df = await getAnomaliesSummary(
                    this.equipment,
                    this.facilityName,
                    {'start': this.range.start, 'end': this.range.end}
                )
                if (!df || !df['timestamp'] || df['timestamp'].length === 0) {
                    this.noData = true
                    this.loading = false
                    this.loadingFirst = false
                    return
                }
                let colorscaleValue = [
                    [0, this.unifiedIsThemeDark ? "rgb(31, 119, 180)" : '#0000FF'],
                    [1, this.unifiedIsThemeDark ? "rgb(214, 39, 40)" : '#FF0000']
                ]
                this.loadingFirst = false
                this.mydata = [{
                    x: df['timestamp'],
                    y: _.map(df['timestamp'], function(x) {return 'score'} ),
                    z: df['value'],
                    type: 'heatmap',
                    mode: 'markers',
                    colorscale: colorscaleValue,
                    zmin:0,
                    zmax:1
                }]
                let dfsum = await getAnomalies(
                    this.equipment,
                    this.facilityName,
                    {'start': this.range.start, 'end': this.range.end},
                    null,
                    true
                )


                let uniques=[...new Set(dfsum['sensor_name'])]
                this.mySumData = [{
                    x: dfsum['timestamp'],
                    y: dfsum['sensor_name'],
                    z: dfsum['value'],
                    type: 'heatmap',
                    mode: 'markers',
                    colorscale: colorscaleValue,
                    zmin:0,
                    zmax:1
                }]
                this.sumLayout.height=Math.max(400,24*uniques.length)
                this.loading = false
                let me=this;
                setTimeout(function(){ me.initPlotlySync()}, 400);
            },
            async handleClick1(data) {

                this.currentTime = data.points[0].x
                let startDate = moment(data.points[0].x).format('YYYY-MM-DD HH:mm:ss')
                let endDate = moment(data.points[0].x).format('YYYY-MM-DD HH:mm:ss')
                let df = await getAnomalies(
                    this.equipment,
                    this.$store.state.pointsListStore.pointsList.facility_name,
                    {'start': startDate, 'end': endDate}
                )
                let output = {
                    x: [],
                    y: [],
                    z: []
                }
                for (let i=0; i <df['timestamp'].length; i++) {
                    let variables = df['name'][i].split("__")
                    output.x.push(variables[0])
                    output.y.push(variables[1])
                    output.z.push(df['value'][i])
                    output.y.push(variables[0])
                    output.x.push(variables[1])
                    output.z.push(df['value'][i])
                }
                let colorscaleValue = [
                    [0, this.unifiedIsThemeDark ? "rgb(31, 119, 180)" : '#0000FF'],
                    [1, this.unifiedIsThemeDark ? "rgb(214, 39, 40)" : '#FF0000']
                ]
                let axis=output['x'].reduce((unique,item)=>unique.includes(item) ? unique : [...unique,item], []).sort();
                this.layout2.xaxis.categoryorder='array';
                this.layout2.xaxis.categoryarray=axis;
                this.layout2.yaxis.categoryorder='array';
                this.layout2.yaxis.categoryarray=axis;
                this.layout2.height=Math.max(400,25*axis.length)
                this.mydata2 = [{
                    x: output['x'],
                    y: output['y'],
                    z: output['z'],
                    type: 'heatmap',
                    mode: 'markers',
                    colorscale: colorscaleValue,
                    zmin:0,
                    zmax:1
                }]
                this.layout2.title.text = this.$options.filters.translate("Issues Diagnostics for")+" " + this.currentTime
                let me=this

                setTimeout(function(){ me.initPlotlySync()}, 600);
            },
            handleClickMatrix(data) {
                this.variableX = data.points[0].x
                this.variableY = data.points[0].y
                this.$refs.anomalyscatter.refresh()
            },
            handleClickJump() {
                let startDate=new Date(this.range.start);
                let endDate=new Date(this.range.end);
                if(this.currentTime){
                    startDate = new Date(this.currentTime)
                    startDate.setDate(startDate.getDate() - 3)
                    endDate = new Date(this.currentTime)
                    endDate.setDate(endDate.getDate()+3)
                }
                let output = {
                    path: '/equipment-plots',
                    query: {
                        rangeStart: startDate.toISOString().slice(0,10),
                        rangeEnd: endDate.toISOString().slice(0,10),
                        equipment: this.equipment
                    }
                }
                if(this.currentTime){
                    output.query.highlightTime=this.currentTime
                }
                this.$router.push(output)
            },
            handleMaintenanceClick(){
                let startDate=moment(this.$refs.plot2.$refs.container.layout.xaxis.range[0]).format('YYYY-MM-DD HH:mm:ss')
                let endDate=moment(this.$refs.plot2.$refs.container.layout.xaxis.range[1]).format('YYYY-MM-DD HH:mm:ss')
                let newmr={
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment': this.equipment,
                    'maintenance_date_from': startDate,
                    'maintenance_date_to': endDate,
                    'maintenance_label':'Anomaly',
                    'url': '/modelsummary?equipment='+this.equipment+'&rangeStart='+startDate+"&rangeEnd="+endDate
                }
                this.maintenanceItem={...newmr}
                this.maintenanceDialog=true
            }
        },
        mounted () {
            this.refresh()
        }
    }
</script>

<style scoped>

</style>
